<app-alert level="danger" *ngIf="error">{{error}}</app-alert>

<ng-container *ngIf="isLoaded">
    <div class="row">
        <div class="col-9 col-sm-6 form-field">
            <input class="form-control"
                   (input)="search($event)"
                   [placeholder]="'planSummary_lblSearch' | translate"
                   maxlength="50"
                   [disabled]="total < 1">
        </div>
    </div>

    <app-alert level="info" *ngIf="total == 0">{{'planSummary_seminars_empty' | translate}}</app-alert>

    <div *ngFor="let g of seminarsByYear">
        <div class="text-top mb-2">
            <span (click)="util.toggle(g)" class="seminar-year-label">
                {{g.year}}{{'planSummary_yearPostfix' | translate}}
                <i class="fi fi-rs-angle-circle-{{util.isExpanded(g) ? 'down' : 'right'}}"></i>
            </span>
        </div>

        <app-table [columns]="columns" [rows]="g.seminars" pageSize="20" sortBy="Date" *ngIf="util.isExpanded(g)">
            <ng-template #rowTemplate let-row>
                <tr>
                    <td>
                        <div class="hidden-md-down">
                            {{row.Theme}}
                            <ng-container *ngIf="row.IsRemote">&nbsp;({{'planSummary_seminars_remote' | translate}})</ng-container>
                        </div>
                        <div class="hidden-lg-up info-row text-top">
                            {{row.Theme}}
                            <ng-container *ngIf="row.IsRemote">&nbsp;({{'planSummary_seminars_remote' | translate}})</ng-container>
                        </div>
                        <div class="hidden-lg-up info-row">
                            <i class="fi fi-rs-calendar-clock"></i>
                            <span>
                                {{row.Date ? (row.Date | appDate) : ('planSummary_seminars_noDate' | translate)}}
                                <ng-container *ngIf="row.Time"> {{row.Time}}</ng-container>
                            </span>
                        </div>
                        <div class="hidden-lg-up info-row" *ngIf="row.Instructor?.trim()">
                            <i class="fi fi-rs-user"></i>{{row.Instructor}}
                        </div>
                        <div class="hidden-lg-up info-row" *ngIf="row.Location?.trim()">
                            <i class="fi fi-rs-marker"></i>
                            <a href="{{row.Location}}" target="_blank" *ngIf="row.IsRemote">{{row.Location}}</a>
                            <ng-container *ngIf="!row.IsRemote">{{row.Location}}</ng-container>
                        </div>
                        <div class="hidden-lg-up info-row" *ngIf="row.AdditionalInformation?.trim()">
                            <i class="fi fi-rs-info"></i>
                            {{row.AdditionalInformation}}
                        </div>
                    </td>
                    <td class="hidden-md-down">
                        {{row.Date ? (row.Date | appDate) : ('planSummary_seminars_noDate' | translate)}}
                        <ng-container *ngIf="row.Time"> {{row.Time}}</ng-container>
                    </td>
                    <td class="hidden-md-down">
                        <div class="info-row" *ngIf="row.Instructor?.trim()">
                            <i class="fi fi-rs-user"></i>
                            {{row.Instructor}}
                        </div>
                        <div class="info-row" *ngIf="row.Location?.trim()">
                            <i class="fi fi-rs-marker"></i>
                            <a href="{{row.Location}}" target="_blank" *ngIf="row.IsRemote">{{row.Location}}</a>
                            <ng-container *ngIf="!row.IsRemote">{{row.Location}}</ng-container>
                        </div>
                        <div class="info-row" *ngIf="row.AdditionalInformation?.trim()">
                            <i class="fi fi-rs-info"></i>
                            {{row.AdditionalInformation}}
                        </div>
                    </td>
                    <td>
                        <span class="badge"
                              *ngIf="row.attendancyStatusName"
                              [class.text-bg-light]="row.AttendancyStatus === undefined"
                              [class.text-bg-success]="row.AttendancyStatus === true"
                              [class.text-bg-danger]="row.AttendancyStatus === false">
                            {{row.attendancyStatusName}}
                        </span>
                    </td>
                </tr>
            </ng-template>
        </app-table>
    </div>
</ng-container>
